/* Credits */
$('figure:not(.mlmi-blockquote)').each(function() {
  $(this).find('figcaption').after('<button class="figcaption__toggle"><i class="icon-photo"></i></button>');
  $(this).find('.figcaption__toggle, figcaption').click(function() {
    $(this).closest('figure').toggleClass('--open');
    return false;
  })
})
